import { render, staticRenderFns } from "./CustomAttribute.vue?vue&type=template&id=e2984cbe&scoped=true&"
import script from "./CustomAttribute.vue?vue&type=script&lang=js&"
export * from "./CustomAttribute.vue?vue&type=script&lang=js&"
import style0 from "./CustomAttribute.vue?vue&type=style&index=0&id=e2984cbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2984cbe",
  null
  
)

export default component.exports